<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <faq-form/>
        </b-card>
    </div>
</template>

<script>
    import FaqForm from '~/components/forms/admin/faq/form'

    export default {
        name: 'create',

        components: {
            'faq-form': FaqForm,
        },
    }
</script>

<style lang="css" scoped>
</style>